/**
 * Formats a fluid volume (stored as ml) for display,
 * converting to fl oz when isMetric is false.
 * Caps the displayed value at 9999.
 */
export function formatFluid(ml: number, isMetric: boolean): string {
  const capped = Math.min(ml, 9999);
  if (isMetric) return `${capped} ml`;
  return `${(capped * 0.033814).toFixed(0)} fl oz`;
}
